import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import PrimaryButton from 'components/primary-button'

import styles from './empty-events.css'

const EmptyEvents = ({ action, description, link }) => (
  <div styleName="empty-events">
    <div styleName="description">{description}</div>

    {link &&
      <a href={link} styleName="link">
        <PrimaryButton fluid label={action} />
      </a>
    }
  </div>
)

EmptyEvents.propTypes = {
  action: PropTypes.string,
  description: PropTypes.any,
  link: PropTypes.string,
}

export default CSSModules(EmptyEvents, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/empty-events/empty-events.js
 **/